import { createContext, useState, useMemo, useRef } from "react";
import { useSessionState } from "../Utils/useSessionState";
import { useMediaQuery } from "@mui/material";

const CURRENT_USER_INITIAL_STATE = {
  profileID: null,
  companyID: null,
  authUser: null,
};

const CURRENT_COMPANY_INITIAL_STATE = {
  companyID: null,
  iconURL: null,
  companyName: null,
};

export const GlobalContext = createContext({});

export const GlobalProvider = (props) => {
  const [firebaseState] = useState(props.fsvc);
  const [optionState, setOptionState] = useSessionState("optionState", {
    nav: "dashboard",
    page: null,
  });
  const [buildingCampaign, setBuildingCampaign] = useState({});
  const [linking, setLinking] = useState(false);
  const [userBrowserName, setUserBrowserName] = useState("");
  const [signError, setSignError] = useState("");
  const [signLoad, setSignLoad] = useState(
    process.env.NODE_ENV === "test" ? false : true,
  );
  const [notFound, setNotFound] = useState(false);
  const [currentUser, setCurrentUser] = useState(CURRENT_USER_INITIAL_STATE);
  const [verifying, setVerifying] = useState(false);
  const [signUpEmail, setSignUpEmail] = useState();
  const [signUpInviteId, setSignUpInviteId] = useState();
  const [customToken, setCustomToken] = useState();
  const [tokenLoading, setTokenLoading] = useState(false);
  const [competitionList, setCompetitionList] = useState();
  const [companyState, setCompanyState] = useState(
    CURRENT_COMPANY_INITIAL_STATE,
  );
  const [rankData, setRankData] = useState();
  const [userTopTryps, setUserTopTryps] = useState();
  const [userStateEmail, setUserStateEmail] = useState();
  const [userState, setUserState] = useState(CURRENT_USER_INITIAL_STATE);
  const [userRankInfo, setUserRankInfo] = useState();
  const [themeMode, setThemeMode] = useState("light");
  const [keyHash, setKeyHash] = useState();
  const [pageColours, setPageColours] = useState({});

  const mobileView = useMediaQuery("(max-width:743px) and (min-width:300px)");
  const tabletView = useMediaQuery("(max-width:1279px) and (min-width:744px)");
  const desktopView = useMediaQuery("(min-width:1280px)");
  const largeView = useMediaQuery("(min-width:2000px)");

  const contactEmail = useRef("hello@trypscore.com");

  const toggleThemeMode = () => {
    setThemeMode(themeMode === "light" ? "dark" : "light");
  };

  const store = useMemo(
    () => ({
      mobileView,
      tabletView,
      firebaseState,
      optionState,
      setOptionState,
      buildingCampaign,
      setBuildingCampaign,
      companyState,
      setCompanyState,
      linking,
      setLinking,
      userBrowserName,
      setUserBrowserName,
      signError,
      setSignError,
      signLoad,
      setSignLoad,
      notFound,
      setNotFound,
      userRankInfo,
      setUserRankInfo,
      currentUser,
      setCurrentUser,
      verifying,
      setVerifying,
      signUpEmail,
      setSignUpEmail,
      signUpInviteId,
      setSignUpInviteId,
      customToken,
      setCustomToken,
      tokenLoading,
      setTokenLoading,
      contactEmail: contactEmail.current,
      competitionList,
      setCompetitionList,
      desktopView,
      largeView,
      userState,
      setUserState,
      userStateEmail,
      setUserStateEmail,
      themeMode,
      toggleThemeMode,
      keyHash,
      setKeyHash,
      userTopTryps,
      setUserTopTryps,
      rankData,
      setRankData,
      pageColours,
      setPageColours,
    }),
    [
      mobileView,
      tabletView,
      firebaseState,
      optionState,
      setOptionState,
      buildingCampaign,
      companyState,
      rankData,
      linking,
      userBrowserName,
      signError,
      signLoad,
      notFound,
      currentUser,
      userRankInfo,
      verifying,
      signUpEmail,
      signUpInviteId,
      customToken,
      tokenLoading,
      competitionList,
      desktopView,
      largeView,
      userState,
      userStateEmail,
      themeMode,
      keyHash,
      userTopTryps,
      pageColours,
      setPageColours,
    ],
  );

  return (
    <GlobalContext.Provider value={store}>
      {props.children}
    </GlobalContext.Provider>
  );
};
